// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"738":"b6b4b9b9","966":"21545fa7"}[chunkId] + ".chunk.js";
};